<i18n
  src="@/locales/views/organization/process/harvest_export/show_harvested_batch.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_exp_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>

<template>
  <go-back-link :text="$t('labels.go_back_link')" :name="routeName('show_process')" :params="{
    organization_id: organization_id,
    harvest_process_id: harvest_process_id
  }" />
  <bread-crumbs :labels="[module_name, harvest_process.name]" />
  <template v-if="load_data_general">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.week") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.week }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.registered_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(exported_batch.registered_at) }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.batch_code") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.batch_code }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.producer") }}
                </dt>
                <dd class="content-data" v-if="exported_batch.producer">
                  {{ exported_batch.producer.producer_org_code }} -
                  {{ exported_batch.producer.producer_code }} -
                  {{ exported_batch.producer.fullname }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.crop_field") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.crop_field?.name }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.total_amount") }}
                </dt>
                <dd class="content-data">
                  {{ numberWithPrecision(exported_batch.total_amount) }} Kg
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.agro_exporter") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.agro_exporter_process?.name }} -
                  {{ exported_batch.agro_exporter_process.agro_exporter?.name }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.exported_batch.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.packing_house_process?.name }} -
                  {{ exported_batch.packing_house_process.packing_house?.name }}
                </dd>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-2" v-if="exported_batch.packages.length == 1">
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.exporter_process_crop_category") }}
                </dt>
                <dd class="content-data">
                  {{
                    exported_batch.packages[0].exporter_process_crop_category
                      .agro_exporter_crop_category.crop_category.name
                  }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.exporter_process_brand") }}
                </dt>
                <dd class="content-data">
                  {{
                    exported_batch.packages[0].exporter_process_brand
                      .agro_exporter_brand.name
                  }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.exporter_process_crop_variety") }}
                </dt>
                <dd class="content-data">
                  {{
                    exported_batch.packages[0].exporter_process_crop_variety
                      .agro_exporter_crop_variety.crop_variety.name
                  }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.exporter_process_crop_size") }}
                </dt>
                <dd class="content-data">
                  {{
                    exported_batch.packages[0].exporter_process_crop_size
                      .agro_exporter_crop_size.crop_size.name
                  }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.process_line") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.packages[0].process_line?.name }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.quantity") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.packages[0].quantity }}
                  {{
                    $t("model.package.exporter_process_crop_package_value", {
                      name: exported_batch.packages[0]
                        .exporter_process_crop_package.name,
                      weight:
                        exported_batch.packages[0].exporter_process_crop_package
                          .net_weight
                    })
                  }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.package.total_buy_price") }}
                </dt>
                <dd class="content-data">
                  {{ exported_batch.packages[0].buy_price_currency?.symbol }}
                  {{ exported_batch.packages[0].total_buy_price }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <destroy-button v-if="!proc_button_destroy" :disabled_button="proc_button_destroy"
              @destroyEvent="destroyExportedBatch()" :label="$t('labels.destroy_button_label')" :title="$t('labels.destroy_button_title', {
                batch_code: exported_batch.batch_code
              })
                " :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')" />
            <destroy-button-processing v-else :label="$t('labels.destroy_button_label')" />
            <span class="space-actions"></span>
            <edit-button @click.prevent="goToEditExportedBatch()" :label="$t('labels.edit_button')" />
          </div>
        </div>
      </div>
    </div>

    <!-- pkg -->
    <template v-if="exported_batch.packages.length > 1">
      <div class="mt-8 flex flex-row justify-between">
        <h1 class="page-title">
          <i class="fa-solid fa-box"></i>
          <span class="space-icon"></span>
          {{ $t("labels.title_packages") }}
        </h1>
      </div>
      <div class="mt-6 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_category") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_brand") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_variety") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_size") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.process_line") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.quantity") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.total_buy_price") }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr class="table-row" v-for="pkg in exported_batch.packages" :key="pkg.id">
                    <td class="table-cell">
                      {{
                        pkg.exporter_process_crop_category
                          .agro_exporter_crop_category.crop_category.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{ pkg.exporter_process_brand.agro_exporter_brand.name }}
                    </td>
                    <td class="table-cell">
                      {{
                        pkg.exporter_process_crop_variety
                          .agro_exporter_crop_variety.crop_variety.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{
                        pkg.exporter_process_crop_size.agro_exporter_crop_size
                          .crop_size.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{ pkg.process_line?.name }}
                    </td>
                    <td class="table-cell">
                      {{ pkg.quantity }}
                      {{
                        $t(
                          "model.package.exporter_process_crop_package_value",
                          {
                            name: pkg.exporter_process_crop_package?.name,
                            weight: pkg.exporter_process_crop_package.net_weight
                          }
                        )
                      }}
                    </td>
                    <td class="table-cell">
                      {{ pkg.buy_price_currency?.symbol
                      }}{{ pkg.total_buy_price }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- pkg inspect -->
    <template v-if="any_package_quality_inspect">
      <div class="mt-8 flex flex-row justify-between">
        <h1 class="page-title">
          <i class="fa-solid fa-box"></i>
          <span class="space-icon"></span>
          {{ $t("labels.title_package_quality_inspects") }}
        </h1>
      </div>
      <div class="mt-6 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.package_quality_inspects") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_category") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_brand") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_variety") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.exporter_process_crop_size") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.process_line") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.package.quantity") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.quality_inspect.observations") }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr class="table-row" v-for="inspect in inspects_with_packages" :key="inspect.id">
                    <td class="table-cell">
                      {{ inspect.quality_template.name }}
                    </td>
                    <td class="table-cell">
                      {{
                        inspect.package.exporter_process_crop_category
                          .agro_exporter_crop_category.crop_category.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{ inspect.package.exporter_process_brand.agro_exporter_brand.name }}
                    </td>
                    <td class="table-cell">
                      {{
                        inspect.package.exporter_process_crop_variety
                          .agro_exporter_crop_variety.crop_variety.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{
                        inspect.package.exporter_process_crop_size.agro_exporter_crop_size
                          .crop_size.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{ inspect.package.process_line?.name }}
                    </td>
                    <td class="table-cell">
                      {{ inspect.discarded_packages }}
                      {{
                        $t(
                          "model.package.exporter_process_crop_package_value",
                          {
                            name: inspect.package.exporter_process_crop_package?.name,
                            weight: inspect.package.exporter_process_crop_package.net_weight
                          }
                        )
                      }}
                    </td>
                    <td class="table-cell">
                      {{ inspect.quality_inspect.observations }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- hb -->
    <div class="mt-8 flex flex-row justify-between">
      <h1 class="page-title">
        <i class="fa-solid fa-apple-crate"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_harvested_batches") }}
      </h1>
      <new-button @click.prevent="goToNewHarvestedBatch()" :label="$t('labels.new_button')" />
    </div>
    <div class="mt-6 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.registered_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.batch_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_package.number") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_field") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_type") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.harvest_team") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.process_line") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.crop_exp_package") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.crop_category") }}
                  </th>
                  <!-- <th scope="col" class="table-header-cell"> -->
                  <!--   {{ $t("model.harvested_exp_package.crop_size") }} -->
                  <!-- </th> -->
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.number") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-for="harvested_batch in exported_batch.harvested_batches" :key="harvested_batch.id">
                  <tr class="table-row">
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.week }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ dateFormatter(harvested_batch.registered_at) }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.batch_code }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ cropHarPackages(harvested_batch) }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.producer.producer_code }}
                      {{ harvested_batch.producer.fullname }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.crop_field.name }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.crop_type?.name }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.crop_variety?.name }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.harvest_team?.harvest_team_code }}
                    </td>
                    <td class="table-cell" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                      ">
                      {{ harvested_batch.process_line?.name }}
                    </td>
                    <td class="table-cell">
                      {{
                        (harvested_batch.harvested_exp_packages[0] || {})
                          .crop_exp_package?.name
                      }}
                    </td>
                    <td class="table-cell">
                      {{
                        (harvested_batch.harvested_exp_packages[0] || {})
                          .crop_category?.name
                      }}
                    </td>
                    <!-- <td class="table-cell"> -->
                    <!--   {{ -->
                    <!--     (harvested_batch.harvested_exp_packages[0] || {}) -->
                    <!--       .crop_size?.name -->
                    <!--   }} -->
                    <!-- </td> -->
                    <td class="table-cell">
                      {{
                        numberWithPrecision(
                          (harvested_batch.harvested_exp_packages[0] || {})
                            .number
                        )
                      }}
                    </td>
                    <td class="table-cell-action space-x-1" :rowspan="harvested_batch.harvested_exp_packages.length || 1
                        ">
                      <destroy-button v-if="!harvested_batch.proc_button_destroy"
                        @destroyEvent="destroyHarvestedBatch(harvested_batch)" :label="$t('labels.destroy_button_label')"
                        :title="$t('labels.destroy_harvested_batch_button_title', {
                          batch_code: harvested_batch.batch_code
                        })
                          " :message="$t('labels.destroy_harvested_batch_button_message') " :label_confirm="$t('labels.destroy_button_label_confirm') " />
                      <destroy-button-processing v-else :label="$t('labels.destroy_button_label')" />
                      <edit-button :label="$t('labels.edit_button')" @click="goToEditHarvestedBatch(harvested_batch)">
                      </edit-button>
                    </td>
                  </tr>
                  <tr>
                    <template v-for="(
                        harvested_exp_package, idx
                      ) in shiftHarvestedExpPackages(
                        harvested_batch.harvested_exp_packages
                      )" :key="idx">
                      <td class="table-cell">
                        {{ harvested_exp_package.crop_exp_package?.name }}
                      </td>
                      <td class="table-cell">
                        {{ harvested_exp_package.crop_category?.name }}
                      </td>
                      <td class="table-cell">
                        {{ harvested_exp_package.crop_size?.name }}
                      </td>
                      <td class="table-cell">
                        {{ numberWithPrecision(harvested_exp_package.number) }}
                      </td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/process/harvest_export/show_exported_batch.js";
import ManageRequester from "@/views/organization/requesters/process/harvest_export/manage_exported_batch.js";
import ManagePackageRequester from "@/views/organization/requesters/process/harvest_export/manage_harvested_batch.js";

export default {
  name: "OrgProcessPackingShowExportedBatch",
  data() {
    return {
      load_data_general: false,
      proc_button_destroy: false,
      harvest_process: {},
      exported_batch: {},
      packages: []
    };
  },
  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
    exported_batch_id: { required: true }
  },
  computed: {
    package_quality_templates: function () {
      let inspects = this.exported_batch.packages.map(pkg => pkg.package_quality_inspects).flat();
      let templates = [];
      inspects.forEach(inspect => {
        templates.push(inspect.quality_template);
      });
      return templates;
    },
    any_package_quality_inspect: function () {
      return this.package_quality_templates.length > 0;
    },
    inspects_with_packages: function () {
      let inspects = [];
      this.exported_batch.packages.forEach(pkg => {
        pkg.package_quality_inspects.forEach(pqi => {
          inspects.push({...pqi, package: pkg});
        });
      });
      return inspects;
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchHarvestProcess();
      await this.fetchExportedBatch();
      this.load_data_general = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchExportedBatch: async function () {
      let response = await Requester.fetchExportedBatch(
        this.organization_id,
        this.exported_batch_id
      );
      this.exported_batch = response.data;
    },
    shiftHarvestedExpPackages: function (items) {
      return items.slice(1);
    },
    goToEditExportedBatch: function () {
      this.$router.push({
        name: this.routeName("edit_exported_batch"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id,
          exported_batch_id: this.exported_batch_id
        }
      });
    },
    destroyExportedBatch: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await ManageRequester.destroy(
          this.organization_id,
          this.exported_batch_id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_button_destroy = false;
    },
    goToNewHarvestedBatch: function () {
      this.$router.push({
        name: this.routeName("new_harvested_batch"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id,
          exported_batch_id: this.exported_batch_id
        }
      });
    },
    goToEditHarvestedBatch: function (harvested_batch) {
      this.$router.push({
        name: this.routeName("edit_harvested_batch"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id,
          exported_batch_id: this.exported_batch_id,
          harvested_batch_id: harvested_batch.id
        }
      });
    },
    destroyHarvestedBatch: async function (harvested_batch) {
      harvested_batch.proc_button_destroy = true;
      try {
        let response = await ManagePackageRequester.destroy(
          this.organization_id,
          harvested_batch.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.exported_batch.harvested_batches.splice(
          this.packages.indexOf(harvested_batch),
          1
        );
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      harvested_batch.proc_button_destroy = false;
    },
    cropHarPackages: function (harvested_batch) {
      return harvested_batch.harvested_packages
        .map(pkg => `${pkg.number} ${pkg.crop_har_package.name}`)
        .join(", ");
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: this.harvest_process_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
